import 'url-polyfill';
import React from 'react';
import {render} from 'react-dom';
import plausibleInit from 'plausible-tracker/build/main/index';
import {BrowserFetcher} from '@/common/services/fetcher/BrowserFetcher';
import {FeedbackAPI} from '@/feedback/services/FeedbackAPI';
import {ServicesContext} from '@/feedback/contexts/ServicesContext';
import {LocalizerProvider} from '@/common/services/localizer';
import {localizationResources} from '@/feedback/locales';
import {App} from '@/feedback/components/App';
import domains from '@/domains.json';

// TODO add analytic in the html page

(async function initialize() {
	// Initialize internal services
	const fetcher = new BrowserFetcher();
	const feedbackAPI = new FeedbackAPI(fetcher);

	// Read the page params: language and page mode
	const defaultLanguage = domains[DOMAIN_NAME].primaryLanguage;
	const searchParams = new URLSearchParams(location.search);
	const language = searchParams.get('lang') || defaultLanguage;
	const mode = searchParams.get('mode') === 'ads' ? 'ads' : 'general';
	const skin = searchParams.get('skin') || 'unknown';

	// Render the application
	const container = document.querySelector('.root-app');

	const domainConfig = domains[DOMAIN_NAME];

	/** Plausible analytics report service */
	const plausibleAnalytics = plausibleInit({
		domain: domainConfig.analytics.plausible.siteDomain,
		apiHost: domainConfig.analytics.plausible.reportEndpoint,
		trackLocalhost: true,
	});

	plausibleAnalytics.trackPageview({url: `${location.origin}/feedback${mode === 'ads' ? '/ads' : ''}`});

	const appRender = () => {
		render(
			<ServicesContext.Provider value={{feedbackAPI}}>
				<LocalizerProvider language={language} resources={localizationResources}>
					<App mode={mode} skin={skin} domainName={DOMAIN_NAME} />
				</LocalizerProvider>
			</ServicesContext.Provider>,
			container,
		);
	};

	appRender();

	if (module.hot) {
		module.hot.accept('@/components/feedback/App', () => {
			appRender();
		});
	}
})();
